import { Scale, Lock, ShieldCheck, Trash2, MapPin, FileClock } from "lucide-react";
import { PageHeader } from "@/components/shared";
import { Card } from "@/components/ui/card";
import { useLang } from "@/context/LanguageContext";

const ICONS = [Lock, ShieldCheck, FileClock, MapPin, Trash2];

export default function Conformite() {
  const { t } = useLang();
  const items = ICONS.map((Icon, i) => ({ Icon, title: t(`cf_i${i + 1}_t`), text: t(`cf_i${i + 1}_x`) }));

  return (
    <div data-testid="conformite-page">
      <PageHeader title={t("cf_title")} subtitle={t("cf_subtitle")} />
      <div className="flex items-center gap-3 p-4 rounded-lg mb-6 text-white" style={{ background: "#0F2942" }}>
        <Scale className="h-6 w-6 text-sky-300 flex-shrink-0" />
        <p className="text-sm">{t("cf_banner")}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map(({ Icon, title, text }) => (
          <Card key={title} className="p-5 border-slate-200">
            <div className="flex gap-3">
              <div className="h-9 w-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "#E0F2FE" }}>
                <Icon className="h-5 w-5 text-sky-700" />
              </div>
              <div>
                <h3 className="font-head font-semibold text-slate-800">{title}</h3>
                <p className="text-sm text-slate-600 mt-1 leading-relaxed">{text}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
